import { createSelector, createFeatureSelector } from '@ngrx/store';

// Reducers
import * as fromUI from './ui.reducer';
import * as fromSearch from './search.reducer';
import * as fromNotification from './notification.reducer';
import * as fromAccount from '../../my-account/reducers/account.reducer';
import * as fromStaffAccount from '../../staff/my-account/reducers/account.reducer';

// Account state
export interface CoreState {
  ui: fromUI.State;
  search: fromSearch.State;
  account: fromAccount.State;
  notification: fromNotification.State;
  staffAccount: fromStaffAccount.State;
}

// Module state
export interface State {
  core: CoreState;
}

// Export reducers
export const reducers = {
  ui: fromUI.reducer,
  search: fromSearch.reducer,
  account: fromAccount.reducer,
  notification: fromNotification.reducer,
  staffAccount: fromStaffAccount.reducer
};



// WEBPACK FOOTER //
// ./src/app/core/reducers/index.ts